import { GiftIcon } from "../Plans/Icons/GiftIcon";
import { SilverIcon } from "../Plans/Icons/SilverIcon";
import { PlanCard } from "../Plans/PlanCard";
import { useContent } from "../../i18n";
import "./style.scss";

export const PrimaryPlans = () => {
  const { plans } = useContent();

  const plansList = [
    {
      name: plans.silver.name,
      tag: plans.silver.tag,
      description: plans.silver.d,
      icon: <SilverIcon />,
      badge: true,
    },
    {
      name: plans.gift.name,
      tag: plans.gift.tag,
      description: plans.gift.d,
      icon: <GiftIcon />,
    },
  ];

  return (
    <div className="primary-plans-wrapper">
      <h2>{plans.primaryTitle}</h2>
      <div className="container">
        <div className="plan-card-container">
          {plansList.map((plan) => (
            <PlanCard plan={plan} key={plan.name} />
          ))}
        </div>
      </div>
    </div>
  );
};
